<bread-crumb></bread-crumb>

<h2 class="v_center">
    <button mat-icon-button [routerLink] = "['/dashboard/admin']" class="f_left">
        <mat-icon>arrow_back</mat-icon>
    </button>
    {{ 'zimbrainstance.manage' | translate }} 
</h2>

<mat-card class="card width-field-100 b_space">
    <mat-card-content class="card-content">
        <form #f = "ngForm">

            <div fxLayout="row">

                <mat-form-field fxFlexOffset="2" fxFlex = "20">
                  <mat-label> {{ 'generic.search' | translate }} </mat-label>
                  <input  matInput  type="text" placeholder="" [(ngModel)]="zimbrainstance_search.probe" name="probe">
                </mat-form-field>
                <button mat-button color="primary" (click)="search()" [ngStyle]="getTextColorStyle()"> {{ 'generic.search' | translate }} </button>

            </div>

        </form>

    </mat-card-content>
</mat-card>


<div class="t_right button_div" >
    <button mat-raised-button color="primary" class="l_space" [ngStyle]="getBackgroundColorStyle()" [routerLink]="['/dashboard/admin/zimbrainstance/create']"> 
        <mat-icon>add_circle</mat-icon>  {{ 'generic.add' | translate }} 
    </button>
</div>


<mat-paginator  class="mat-elevation-z1"
              [length]                  = "total_rows"
              [pageSize]                = "per_page"
              [pageSizeOptions]         = "[10, 20, 30, 40 , 50]"
              [showFirstLastButtons]    = true
              (page)                    = "onPaginateChange($event)" >
              >
</mat-paginator>

<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<table mat-table [dataSource]="plain_list" class="mat-elevation-z1" matSort (matSortChange)="sortData($event)" matSortActive="id">

    <!-- code Column -->
    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef  > {{ 'generic.code' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.code }} </td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef  > {{ 'generic.name' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <!-- code Column -->
    <ng-container matColumnDef="url">
        <th mat-header-cell *matHeaderCellDef  > {{ 'zimbrainstance.url' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.url }} </td>
    </ng-container>

     <!-- domain_name Column -->
     <ng-container matColumnDef="domain">
        <th mat-header-cell *matHeaderCellDef  > {{ 'zimbrainstance.domain' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.domain_name }} </td>
    </ng-container>

    
    
     <!-- Actions Column -->
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef > {{ 'generic.actions' | translate }} </th>

        <td mat-cell *matCellDef="let element"> 
             <!-- IF ITEM IS NOT LOCKED OR IS LOCKED BY SAME CURRENT USER -->
            <span>

                <button mat-icon-button (click)="editZimbraInstance(element.id)" [ngClass] = "'pointer'" >
                    <mat-icon matTooltip="{{ 'generic.edit' | translate }}" > create </mat-icon>
                </button>

                <button mat-icon-button (click)="deleteZimbraInstance(element.id)" [ngClass] = "'pointer'">
                    <mat-icon  matTooltip="{{ 'generic.delete' | translate }}">delete</mat-icon>
                </button>

            </span>
        </td>
        
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayed_columns;"></tr>
</table>

<div fxLayout="row" *ngIf="!plain_list.length" class="mat-elevation-z1 centered_spaced" >
    {{ 'generic.norecord' | translate }}
</div>
